export default __webpack_public_path__ + "static/media/VideoConferenceBlur.4c22c41c.PNG";